module.exports = __webpack_public_path__ + "static/media/icon-select-blue.029b7a86.svg";